<template>
  <b-modal
    :id="id"
    size="lg"
    body-class="bg-white"
    :title="title"
    cancel-variant="default"
    @show="initModal"
    @hidden="resetModal"
    @ok="handleClick"
  >
    <b-form-group
      v-for="form in fields"
      :key="form.label"
      :id="form.id"
      :label="capitalizeEachWord(form.label)"
      :label-for="`${form.label}-${form.id}`"
    >
      <b-form-input
        v-if="['title', 'author', 'url', 'ask'].includes(form.label)"
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
        required
      ></b-form-input>

      <b-form-textarea
        v-if="['description', 'answer'].includes(form.label)"
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
        rows="5"
        required
      ></b-form-textarea>

      <b-form-datepicker
        v-else-if="form.label == 'event_start_at' || form.label == 'event_end_at'"
        :min="new Date()"
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
      ></b-form-datepicker>

      <div v-else-if="form.label == 'image' || form.label == 'icon'">
        <div v-if="form.src" class="mb-2">
          <img style="width: 200px; height: 200px; object-fit: contain" :src="form.src" alt="image" />
        </div>
        <b-form-file accept=".png,.jpg,.jpeg" @change="handleChangeFile($event, form)"></b-form-file>
      </div>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'DataModal',
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Modal',
    },
    forms: {
      type: Array,
      default: () => [],
    },
    formsData: {
      type: Object,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: null,
      imagePath: null,
    }
  },
  methods: {
    initModal() {
      this.fields = this.forms.reduce((acc, f, idx) => {
        if (f == 'no' || f == 'aksi' || f == 'created_at' || f == 'updated_at') return [...acc]

        if (f == 'image') {
          return [
            ...acc,
            {
              id: `${f}-${idx}`,
              label: f,
              // value: this.isEdit ? this.formsData[f] : [],
              value: null,
              src: this.formsData ? this.formsData[f] : '',
            },
          ]
        }

        return [
          ...acc,
          {
            id: `${f}-${idx}`,
            label: f,
            value: this.isEdit ? this.formsData[f] : '',
          },
        ]
      }, [])
    },
    resetModal() {
      this.fields = null
      this.imagePath = null
    },
    handleClick() {
      this.$emit('click-ok', this.fields)
    },
    handleChangeFile(e, form) {
      const file = e.target.files[0]
      if (!file) return
      const newname = `${new Date().getTime()}${file.name}`
      const renamedFile = new File([file], newname, { type: file.type })
      const url = URL.createObjectURL(file)
      this.imagePath = url
      form.value = renamedFile
      form.src = url
    },
    capitalizeEachWord(str) {
      return str
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    },
  },
}
</script>
